import { useContext } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
} from '@mui/material';
import { useModal } from 'components/Modals';
import { useForm } from 'react-hook-form';
import { DropsContext } from 'contexts/DropsContext';
import { AnuncioContext } from 'contexts/AnuncioContext';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';

const CopyModal = ({ item, callback }) => {
  const defaultValues = {
    id: item?.id,
    codigo: item?.codigo,
    integra_access_id: item?.integra_access_id,
    // listing_type_id: null
  };
  const { closeModal } = useModal();
  const { control, handleSubmit } = useForm({ defaultValues });
  const { drops } = useContext(DropsContext);
  const { postLoading, copyAnuncio } = useContext(AnuncioContext);

  const onSubmit = (data) => copyAnuncio({ data, cb: callback });

  return (
    <>
      <DialogTitle>Copiar Anúncio</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color="text.secondary">{item?.anuncio}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              name="integra_access_id"
              control={control}
              label="Loja"
              options={drops?.IntegraAccess?.filter(
                (f) => f?.label === item?.marketplace
              )}
            />
          </Grid>
          {/* <Grid item xs={12}>
            <Dropdown
              name="listing_type_id"
              control={control}
              label="Tipo de listagem"
              options={[
                { value: 'free', label: 'Grátis' },
                { value: 'bronze', label: 'Bronze' },
                { value: 'silver', label: 'Prata' },
                { value: 'gold_special', label: 'Clássico' },
                { value: 'gold_premium', label: 'Diamante' },
                { value: 'gold_pro', label: 'Premium' },
              ]}
            />
          </Grid> */}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit(onSubmit)} loading={postLoading}>
          Confirmar
        </Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default CopyModal;
